import React, { useState } from "react"
import { Link, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"
import "./css/Blog.min.css"

import { blogPosts, allItems } from "~content/blog/blogPosts"

// Group by Month
const groupByMonth = (items) => {
  const groups = {}
  items.forEach(item => {
    const date = new Date(item.footnote.replace("Published on ", ""))
    const key = date.toLocaleString("default", { month: "long", year: "numeric" })
    if (!groups[key]) groups[key] = []
    groups[key].push(item)
  })
  return groups
}

//  Group by Year
const groupByYear = (items) => {
  const groups = {}
  items.forEach(item => {
    const date = new Date(item.footnote.replace("Published on ", ""))
    const key = date.getFullYear().toString()
    if (!groups[key]) groups[key] = []
    groups[key].push(item)
  })

  return Object.fromEntries(
    Object.entries(groups).sort(([a], [b]) => b - a)
  )
}

const BlogAccordion = ({ items }) => {
  const { pathname } = useLocation()
  // const grouped = groupByMonth(items)
  // const months = Object.keys(grouped)

  const grouped = groupByYear(items)       // was groupByMonth
  const years = Object.keys(grouped).sort((a, b) => b - a)

  // Find which month contains the currently active post
  // const activeMonth = months.find(month =>
  //   grouped[month].some(item => item.to === pathname || item.to === pathname + "/")
  // )

  const activeYear = years.find(year =>    // was activeMonth / months
    grouped[year].some(item => item.to === pathname || item.to === pathname + "/")
  )

  const [openYear, setOpenYear] = useState(activeYear || years[0] || null)  // was openMonth

  const toggle = (year) => {
    setOpenYear(prev => prev === year ? null : year)
  }

  // Open the active month if found, otherwise default to first month
  // const [openMonth, setOpenMonth] = useState(activeMonth || months[0] || null)

  // const toggle = (month) => {
  //   setOpenMonth(prev => prev === month ? null : month)
  // }

  // Normalize for comparison — handle trailing slash differences
  const normalizePath = (path) => path.replace(/\/$/, "")
  const currentPath = normalizePath(pathname)

  return (
    <div>
    {years.map(year => (
      <div key={year} className="blog-accordion-group">
        <button
          className={`blog-accordion-header ${openYear === year ? "is-open" : ""}`}
          onClick={() => toggle(year)}
        >
          <span className="blog-accordion-month">{year}</span>
          <span className="blog-accordion-meta">
            <span className="blog-accordion-count">{grouped[year].length} posts</span>
            <span className="blog-accordion-arrow">{openYear === year ? "▲" : "▼"}</span>
          </span>
        </button>

        {openYear === year && (
          <ul className="blog-accordion-list">
            {grouped[year].map((item, i) => {
              const isActive = normalizePath(item.to) === currentPath
              return (
                <li key={i} className="blog-accordion-item">
                  <Link
                    to={item.to}
                    className={`blog-accordion-link ${isActive ? "is-active" : ""}`}
                  >
                    {item.title}
                    <br />
                    <span className="blog-footdate">{item.date}</span>
                  </Link>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    ))}
  </div>
  )
}

const aside = {
  asideWrapper: children => <div className="blog-aside" children={children} />,
  title: "Blog",
  items: allItems,
  component: <BlogAccordion items={allItems} />,
  footer: null,
}

export default aside